export const EXTERNAL_LINKS = {
  // Academia Bistro - Configuraciones básicas
  BISTRO_ACADEMY_FISCAL_CONFIG_AR: 'https://bistrosoft.com/academia/configuraciones-basicas/#tab-facturacion-electronica',
  
  // Knowledge Base URLs por país
  KNOWLEDGE_BASE_MX: 'https://bistrosoft.com/ayuda/facturacion-electronica-mexico/',
  KNOWLEDGE_BASE_AR: 'https://bistrosoft.com/academia/configuraciones-basicas/#tab-facturacion-electronica',
  KNOWLEDGE_BASE_DEFAULT: 'https://bistrosoft.com/ayuda/como-cargar-tus-datos-fiscales-para-poder-emitir-facturas-desde-tu-bistrosoft/',
  
  // Social Media
  FACEBOOK: 'https://www.facebook.com/bistrosoft/',
  INSTAGRAM: 'https://www.instagram.com/bistrosoft/',
  LINKEDIN: 'https://www.linkedin.com/company/bistrosoft/?originalSubdomain=ar'
};
